// eslint-disable-next-line filenames/match-exported
import { routerPlugin } from "./plugin";
export default routerPlugin;
export * from 'react-router-dom';